export const getDifferenceHours = (inicio: any, fim: any) => {
  let hours = Math.abs(fim - inicio) / 36e5;
  let minutes = hours * 60
  return minutes
}
